import { render, staticRenderFns } from "./OverseaService.vue?vue&type=template&id=6939acb1&scoped=true"
import script from "./OverseaService.vue?vue&type=script&lang=js"
export * from "./OverseaService.vue?vue&type=script&lang=js"
import style0 from "./OverseaService.vue?vue&type=style&index=0&id=6939acb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6939acb1",
  null
  
)

export default component.exports